module.exports = __webpack_public_path__ + "img/logo.046d753c.png";